<template>
  <div class="container">
    <l-tables
      :tableConfig="tableConfig"
      :columnId="columnId"
      ref="table"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <a-input 
          v-model="keyword" 
          @change="search" 
          maxlength="30" 
          :placeholder="$t('admin.content.video.list.searchPlaceholder')"
        >
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="keyword"
            slot="suffix"
            @click=";(keyword = undefined), search()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
        </a-input>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('admin.content.video.list.create') }}{{ columnTitle }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('admin.content.video.list.create') }}{{ columnTitle }}</a-button>
      </template>
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'

export default {
  components: {
    LTables
  },
  data() {
    return {
      nullImg: require('@/assets/img/no_data_video.png'),
      keyword: undefined,
      searchData: {
        keyword: ''
      },
      tableConfig: {
        tableName: this.$t('admin.content.video.list.title'),
        tableColumns: [
          {
            title: this.$t('admin.content.video.list.columns.id'),
            dataIndex: 'index',
            key: 'index'
          },
          {
            title: this.$t('admin.content.video.list.columns.title'),
            dataIndex: 'title'
          },
          {
            title: this.$t('admin.content.video.list.columns.status'),
            width: 80,
            dataIndex: 'statusName',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.content.video.list.filters.status.open'), value: '开启' },
              { text: this.$t('admin.content.video.list.filters.status.closed'), value: '关闭' }
            ]
          },
          {
            title: this.$t('admin.content.video.list.columns.createdAt'),
            dataIndex: 'createdAt'
          },
          {
            title: this.$t('admin.content.video.list.columns.updatedAt'),
            dataIndex: 'updatedAt'
          },
          {
            title: this.$t('admin.content.video.list.columns.recommend'),
            width: 110,
            dataIndex: 'recommendName',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.content.video.list.filters.recommend.recommended'), value: '推荐' },
              { text: this.$t('admin.content.video.list.filters.recommend.notRecommended'), value: '未推荐' }
            ]
          },
          {
            title: this.$t('admin.content.video.list.columns.operations'),
            dataIndex: 'operate',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.content.video.list.deleteConfirm.title'),
          content: this.$t('admin.content.video.list.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/portal/video/list',
          del: '/admin/portal/video/delete'
        },
        // tableData:[],
        tableEditRouteNName: 'videoAdd'
      },
      columnTitle: this.$route.query.columnTitle,
      pColumnTitle: this.$route.query.pColumnTitle,
      noCreatText: this.$t('admin.content.video.list.noData')
    }
  },
  watch: {
    $route() {
      this.columnId = this.$route.query.columnId
      this.tableConfig.tableName = this.$route.query.columnTitle
      this.$ref.table.getList()
    }
  },
  created() {
    this.columnId = this.$route.query.columnId
    const { columnTitle, pColumnTitle } = this.$route.query
    this.noCreatText = this.$t('admin.content.video.list.noData') + columnTitle
    this.tableConfig.tableName = pColumnTitle ? `${pColumnTitle}-${columnTitle}` : columnTitle 
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      const filterKey = [
        ['statusName', 'status'],
        ['recommendName', 'isRecommend']
      ]
      const timeSort = {}
      // 升序
      if (sorter.order === 'ascend') {
        timeSort.time_sort = 2
        // 倒序
      } else if (sorter.order === 'descend') {
        timeSort.time_sort = 1
      }
      const result = { ...timeSort }
      filterKey.forEach(item => {
        if (filters[item[0]]) {
          result[item[1]] = filters[item[0]].map(f => {
            if (f === '开启' || f === '未推荐') {
              return 1
            }
            return 2
          })
          result[item[1]] = result[item[1]].length > 1 ? '' : result[item[1]][0]
        }
      })
      getList({ condition: result })
    },
    create() {
      this.$router.push({
        name: 'videoAdd',
        query: {
          columnId: this.columnId,
          columnTitle: this.columnTitle
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  margin-top: 0;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination {
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
.selection {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
  }
}
.noData {
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  flex-direction: column;
  justify-content: center;
  flex-direction: lab;
  height: calc(100% - 120px);
  img {
    width: 285px;
    margin-bottom: 12px;
  }
  > span {
    font-size: 14px;
    color: #0d2340;
    margin-top: -40px;
  }
  button {
    margin-top: 20px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/ .ant-btn.ant-btn-primary {
  width: auto;
}
</style>
